import { useContext, useState } from "react"
import { useEffect } from "react"
import { ACTIONS } from "../../bin/reducerState/reducerState"
import { auth, db } from "../../Lib/Firebase/Firebase"
import { pageWrapper } from "../App/App"
import "./StatusCard.css"
const StatusCard = () => {

  let stateObj = useContext(pageWrapper)

  let [date,setDate] = useState("")
  let [status,setStatus]= useState("")

  

  useEffect(()=>{

      db.once("value",(snapshot)=>{
        try {
          let profile = snapshot.child(auth.currentUser.uid).val() 
          try { 
            stateObj.dispatch({type:ACTIONS.BOOKING_STATUS,payload:profile.bookingStatus})
          setDate(profile.date)
          setStatus(profile.bookingStatus)
          } catch (error) {
            
          }

        } catch (error) {
          
        }
      })
    
  },[db])
 
 
    
  

  

  return ( 
    <div className="StatusCard">
      
      <h4>Booking For: {date}</h4>

      <h3 style={{
        borderColor:
        (status==="Accepted")?"green"
        :
        (status==="pending")?"orange"
        :
        (status==="Declined")?"red":"white"
      }}
      className="StatusCard-Status">Status {status}</h3>

      <article className="StatusCard-info">
        <h6 style={{margin:"0"}}>My minimum callout charge is £35 (this includes labour up to the value of £35).</h6>
        </article>
      
    </div>
   );
}
 
export default StatusCard;